import React from "react";
import logo from "../assets/logo.png";
import { texts } from "../data/langs";
import feather from "feather-icons";
import "../App.css";

export const Nav = (props) => {
  const { setContact } = props;

  const [sttShow, setShow] = React.useState(false);
  const toggleMenu = () => setShow((e) => !e);
  const toggleContact = () => {
    setContact((e) => !e);
    setShow((e) => false);
  };

  // console.log({ sttShow });

  return (
    <header className="limiter">
      <div className="nav_desk line space-bet">
        <img src={logo} className="logo" alt="logo" />
        <nav className="line">
          <a href="#Home">{texts[texts.active].nav.it1}</a>
          <a href="#Serviços">{texts[texts.active].nav.it2}</a>
          <a href="#Trabalhos">{texts[texts.active].nav.it3}</a>
          <a href="#Depoimentos">{texts[texts.active].nav.it4}</a>
          <a href="#Conquistas">{texts[texts.active].nav.it5}</a>
          <a
            onClick={toggleContact}
            // href="https://api.whatsapp.com/send?phone=5511916745093&text=Olá%2C+vi+seu+anúncio+no+Google+e+quero+mais+informações+sobre+o+desenvolvimento+de+software."
            // target="_blank"
            className="btn2"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: feather.icons["message-circle"].toSvg({
                  class: "foo bar",
                  "stroke-width": 3,
                  stroke: "#fff",
                  width: 14,
                  height: 14,
                }),
              }}
            />
            <div style={{ width: 6 }} />
            {texts[texts.active].nav.it6}
          </a>
        </nav>
      </div>

      <div className="nav_mob line space-bet">
        <img src={logo} className="logo" alt="logo" />
        <nav className="line">
          <button onClick={() => setShow((e) => !e)} className="btn2">
            <div
              dangerouslySetInnerHTML={{
                __html: feather.icons["menu"].toSvg({
                  class: "foo bar",
                  "stroke-width": 3,
                  stroke: "#fff",
                  width: 14,
                  height: 14,
                }),
              }}
            />
          </button>
        </nav>
      </div>

      {sttShow && (
        <div className="menu_mob">
          <div
            style={{
              width: "100%",
              alignItems: "end",
            }}
          >
            <button id="closeMenu" className="btn3" onClick={toggleMenu}>
              <div
                style={{ width: "auto" }}
                dangerouslySetInnerHTML={{
                  __html: feather.icons["x"].toSvg({
                    class: "foo bar",
                    "stroke-width": 3,
                    stroke: "#999",
                    width: 16,
                    height: 16,
                  }),
                }}
              />
            </button>
          </div>
          <br />
          <a href="#Home" onClick={toggleMenu}>
            {texts[texts.active].nav.it1}
          </a>
          <a href="#Serviços" onClick={toggleMenu}>
            {texts[texts.active].nav.it2}
          </a>
          <a href="#Trabalhos" onClick={toggleMenu}>
            {texts[texts.active].nav.it3}
          </a>
          <a href="#Depoimentos" onClick={toggleMenu}>
            {texts[texts.active].nav.it4}
          </a>
          <a href="#Conquistas" onClick={toggleMenu}>
            {texts[texts.active].nav.it5}
          </a>
          <a
            // href="https://api.whatsapp.com/send?phone=5511916745093&text=Olá%2C+vi+seu+anúncio+no+Google+e+quero+mais+informações+sobre+o+desenvolvimento+de+software."
            // target="_blank"
            className="btn2"
            onClick={toggleContact}
            // onClick={() => {
            //   window.gtag &&
            //     window.gtag("event", "conversion", {
            //       send_to: "AW-17225078986/gNAbCLef2d0aEMqxx5VA",
            //     });
            // }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: feather.icons["message-circle"].toSvg({
                  class: "foo bar",
                  "stroke-width": 3,
                  stroke: "#fff",
                  width: 14,
                  height: 14,
                }),
              }}
            />
            <div style={{ width: 6 }} />
            {texts[texts.active].nav.it6}
          </a>
        </div>
      )}
    </header>
  );
};
